import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';
import chess_pieces from '../assets/chess_pieces.png';
import cards_row from '../assets/cards_row.png';
import logo_wide from '../assets/logo_wide.png';
import { IoEnterOutline } from 'react-icons/io5';
import { MdArrowBack } from 'react-icons/md'
import TopBar from '../components/TopBar';
import { GAME_TYPES, PLAY_MODES } from '../Constants';
import { callGameServerApi } from '../Helpers';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "landscape";
  const [ error, setError ] = useState(false);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  const [ selectedGame, setSelectedGame ] = useState(null);
  const [ gameId, setGameId ] = useState("");

  const init = () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }

  const checkGameId = async () => {
    if(gameId.trim().length >= 4) {
      setLoading(true);
      await callGameServerApi('check-game-id', { gameId }).then(response => {
        setLoading(false);
        if(response.status === 1) {
          //redirect
          appContext.navTo({
            item: 'browse_game',
            subItem: gameId,
          });
        } else {
          appContext.tellError(response.msg);
        }
      })
    } else {
      appContext.tellError('Invalid Game ID')
    }
  }


  const createMatch = async () => {
    //create match for the selected game
    if(!loading) {
      setError(false);
      setLoading(true);
      let user = await appContext.getLocalUser();
      //console.log(user);
      await callGameServerApi(
        'create-game', 
        { 
          playerId: user.userId,
          userToken: user.userToken,
          invitedId: null,
          playMode: PLAY_MODES.ONLINE,
          gameType: selectedGame,
        }).then(response => {
        if(response.status === 1) {
          appContext.navTo({
            item: 'browse_game',
            subItem: response.uid,
          });
        } else {
          setLoading(false);
          appContext.tellError(response.msg);
          setError(response.msg);
        }
      })
    }
  }


  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();

    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  return (
    <>
      <TopBar title="New Cards Game"/>
      <div className="FullPane"  data-support-top-bar={true}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6' style={{ marginTop: "30px", marginBottom:"30px" }}>
              <div className='row'>

                <div className='col-12'>
                  <h6 className='text-goldish font-light' style={{ fontSize: "20px", marginBottom: "20px" }}>Select Cards Game Type</h6>
                </div>

                <div className='col-6'>
                  <button onClick={() => setSelectedGame(GAME_TYPES.LASTCARD)} className='btn btn-block bg-goldish mNoMargin'>Last Card</button>
                </div>

                <div className='col-6'>
                  <button onClick={() => setSelectedGame(GAME_TYPES.ARUBASTINI)} className='btn btn-block bg-redish mNoMargin'>Arubastini</button>
                </div>

                <div className='col-12'>
                  {
                    (selectedGame === null) ?
                      <div className='row'>
                        <div className='col-12 text-center'>
                          <img src={cards_row} style={{ width: "100%", height: "auto" }} />
                        </div>
                      </div>: <></>
                  }

                  {
                    (selectedGame === GAME_TYPES.LASTCARD) ?
                      <div className='row'>

                        <div className='col-12 text-end' style={{ marginTop: "20px" }}>
                          <h3>Last Card</h3>
                        </div>

                        <div className='col-12 text-start'>
                          <small className='text-muted'>
                            Lastcard ni mchezo wa karata ambapo mshindi ni yule mchezaji ambae atamaliza
                            karata zake kabla ya wachezaji wengine. Ni mchezo unaozipa baadhi ya karata nguvu za ziada
                            'Special Cards' kama vile 2, 7 na 8.
                          </small>
                        </div>

                        {
                          (error) ?
                          <div className='col-12 text-start' >
                            <h6 className='text-redish font-light'>
                              {error}
                            </h6>
                          </div> : <></>
                        }

                        <div className='col-12 text-end' >
                          <button
                            onClick={() => {
                              appContext.activateDialog({
                                message: "Create and host a match for Lastcard",
                                onConfirm: createMatch,
                              })
                            }}
                            className='btn bg-goldish btn-rounded'>
                            Create & Host
                          </button>
                        </div>

                      </div> : <></>
                  }

                  {
                    (selectedGame === GAME_TYPES.ARUBASTINI) ?
                      <div className='row'>
                        <div className='col-12 text-end' style={{ marginTop: "20px" }}>
                          <h3>Arubastini</h3>
                        </div>

                        <div className='col-12 text-start'>
                          <small className='text-muted'>
                            Arubastini ni mchezo wa karata ambapo wachezaji hushindana kukusanya karata zenye thamani kubwa. Jumla
                            ya thamani ni 120 na mshindi ni yule atakaefanikiwa kukusanya karata zenye jumla ya thamani inayozidi 60.
                          </small>
                        </div>

                        {
                          (error) ?
                          <div className='col-12 text-start' >
                            <h6 className='text-redish font-light'>
                              {error}
                            </h6>
                          </div> : <></>
                        }

                        <div className='col-12 text-end' >
                          <button
                            onClick={() => {
                              appContext.activateDialog({
                                message: "Create and host a match for Arubastini",
                                onConfirm: createMatch,
                              })
                            }}
                            className='btn bg-goldish btn-rounded'>
                            Create & Host
                          </button>
                        </div>

                      </div>: <></>
                  }
                </div>
                
                
              </div>
            </div>

            <div className='col-md-6' style={{ marginTop: "30px", marginBottom:"30px" }}>
              <div className='row'>
                <div className='col-12' >
                  <h6 className='text-goldish font-light' style={{ fontSize: "20px", marginBottom: "20px" }}>Or Write Game ID and Join Now</h6>
                </div>

                <div className='col-12'>
                  <div className='form-group'>
                    <label>Game ID</label>
                    <input value={gameId} onChange={(e) => { setGameId(e.target.value); setSelectedGame(null)}} className='form-control' style={{ color: "var(--goldish)" }}/>
                  </div>
                </div>

                <div className='col-12 text-end'>
                  <button onClick={checkGameId} className='btn btn-block bg-faint-black mNoMargin'>
                    <IoEnterOutline size={30}/>
                    &nbsp;
                    Join Now
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )

  
}
